import {Box, Skeleton} from '@mui/material';

import {
  profileComparisonResultEffortGridSx,
  profileComparisonResultScoreCardsSx,
  profileComparisonResultSectionSx,
  profileComparisonSectionCardSx,
} from './profileComparisonSectionStyles';
import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';

export const ProfileComparisonResultSkeleton = () => (
  <Box sx={profileComparisonResultSectionSx} data-testid='profile-comparison-result-skeleton'>
    <EmpionPaper sx={{...profileComparisonSectionCardSx, mb: 0}}>
      <Skeleton variant='rounded' height={56} sx={{mb: 2, borderRadius: '10px'}} />
      <Box sx={profileComparisonResultScoreCardsSx}>
        <Skeleton variant='rounded' height={220} sx={{borderRadius: '12px'}} />
        <Skeleton variant='rounded' height={220} sx={{borderRadius: '12px'}} />
      </Box>
      <Skeleton variant='text' width={180} height={24} sx={{mb: 1.25}} />
      <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', md: 'repeat(3, 1fr)'}, gap: 1.5, mb: 2}}>
        <Skeleton variant='rounded' height={140} sx={{borderRadius: '14px'}} />
        <Skeleton variant='rounded' height={140} sx={{borderRadius: '14px'}} />
        <Skeleton variant='rounded' height={140} sx={{borderRadius: '14px'}} />
      </Box>
      <Box sx={profileComparisonResultEffortGridSx}>
        <Skeleton variant='rounded' height={100} sx={{borderRadius: '14px'}} />
        <Skeleton variant='rounded' height={100} sx={{borderRadius: '14px'}} />
      </Box>
    </EmpionPaper>
  </Box>
);
